import { TimeseriesDataSet } from "../types/timeseries";
import axios from "axios";
import { GetApiResponse } from "../types/api";
import { kebabCase } from "lodash";
import Cookies from "js-cookie";
import { apiV1BaseUrl } from "./index";

const accessToken = () => Cookies.get("accessToken");

export const getClimateTimeseriesByGeographicalUnit = async ({
  country,
  indicator,
  locationId,
  adminLevel,
  type,
}: {
  country: string;
  indicator: string;
  locationId: string;
  adminLevel: string;
  type: string;
}) => {
  try {
    const response = await axios.get<GetApiResponse<TimeseriesDataSet>>(
      `${apiV1BaseUrl}/timeseries/Dekads`,
      {
        params: {
          country,
          indicator,
          locationId,
          adminLevel,
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnomalyTimeseriesByGeographicalUnit = async ({
  country,
  indicator,
  locationId,
  adminLevel,
  months,
  dekads,
  type,
}: {
  country: string;
  indicator: string;
  locationId: string;
  adminLevel: string;
  months: string[];
  dekads: string[];
  type: string;
}): Promise<any[]> => {
  try {
    const response = await axios.get(
      `${apiV1BaseUrl}/timeseries/DekadAnomalies`,
      {
        params: {
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
          country,
          indicator: kebabCase(indicator),
          locationId,
          adminLevel,
          startmonth: months[0],
          endmonth: months[1],
          startdekad: dekads[0],
          enddekad: dekads[1],
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getHybridAnomalyTimeseriesByGeographicalUnitService = async ({
  country,
  locationId,
  adminLevel,
  months,
  dekads,
  hybridIndicatorsJson,
  // soilMoistureValue,
  // precipitationValue,
  // vegetationValue,
  type,
}: {
  country: string;
  adminLevel: string;
  locationId: string;
  // soilMoistureValue: number;
  // precipitationValue: number;
  // vegetationValue: number;
  months: string[];
  dekads: string[];
  hybridIndicatorsJson?: string;
  type: string;
}): Promise<any> => {
  try {
    const response = await axios.get<GetApiResponse<TimeseriesDataSet>>(
      `${apiV1BaseUrl}/timeseries/Hybrid`,
      {
        params: {
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
          country,
          locationId,
          adminLevel,
          hybridIndicatorsJson,
          // soilMoistureValue,
          // vegetationValue,
          // precipitationValue,
          startmonth: months[0],
          endmonth: months[1],
          startdekad: dekads[0],
          enddekad: dekads[1],
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnomaliesGeographicalUnitValuesService = async ({
  country,
  indicator,
  adminLevel,
  startmonth,
  endmonth,
  // year,
  startDekad,
  endDekad,
  type,
}: {
  country: string;
  indicator: string;
  adminLevel: string;
  startmonth: string;
  endmonth: string;
  startDekad: string;
  endDekad: string;
  type: string;
  // year: number;
}): Promise<GetApiResponse<any>> => {
  try {
    const response = await axios.get<GetApiResponse<any>>(
      `${apiV1BaseUrl}/timeseries/DekadRawAnomalies`,
      {
        params: {
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
          country,
          indicator: kebabCase(indicator),
          adminLevel,
          startmonth,
          endmonth,
          startDekad,
          endDekad,
          // startYear: year,
          // endYear: year
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getHybridGeographicalUnitValuesService = async ({
  country,
  adminLevel,
  startmonth,
  endmonth,
  startDekad,
  endDekad,
  // soilMoistureValue,
  // precipitationValue,
  // vegetationValue,
  hybridIndicatorsJson,
  type,
}: {
  country: string;
  indicator: string;
  adminLevel: string;
  startmonth: string;
  endmonth: string;
  startDekad: string;
  endDekad: string;
  hybridIndicatorsJson: string;
  type: string;
}): Promise<GetApiResponse<any>> => {
  try {
    const response = await axios.get<GetApiResponse<any>>(
      `${apiV1BaseUrl}/timeseries/RawHybrid`,
      {
        params: {
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
          country,
          adminLevel,
          startmonth,
          endmonth,
          startDekad,
          endDekad,
          hybridIndicatorsJson,
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getYearRangeService = async ({
  country,
  adminLevel,
  type,
  indicatorsJson,
}: {
  country: string;
  adminLevel: string;
  type: string;
  indicatorsJson: string;
}): Promise<GetApiResponse<{ startYear: number; endYear: number }>> => {
  try {
    const response = await axios.get<
      GetApiResponse<{ startYear: number; endYear: number }>
    >(
      `${apiV1BaseUrl}/timeseries/YearRange`,
      {
        params: {
          type:
            type === "user" && adminLevel !== "1" && adminLevel !== "2"
              ? "user"
              : "system",
          country,
          adminLevel,
          IndicatorsJson: indicatorsJson,
        },
        ...(type === "user" && adminLevel !== "1" && adminLevel !== "2"
          ? {
              headers: {
                ...(accessToken()
                  ? { Authorization: `Bearer ${accessToken()}` }
                  : {}),
              },
            }
          : {}),
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
